import React, { useState } from "react";
import { useWatchState, handler } from "@/store";
import { Wave } from "@/components";
import { checkResult } from "@/common";
import { BaseService, RemindService, UserService } from "@/service";
import moment from "moment";
import { Modal, Button, Form, Input, message, Icon } from "antd";
import "./style.less";

const App = (props) => {

    const [loading, setLoading] = useState(false);
    const [account, setAccount] = useState(undefined);
    const [password, setPassword] = useState(undefined);
    const [[{ title, show, hide, width = 300, vo = {}, state, contrast, callback }]] = useWatchState(["modal.login"])

    const onChangeAccount = e => setAccount(e.target.value)
    const onChangePassword = e => setPassword(e.target.value)
    const onLogin = async () => {
        if (!account || !password) return message.warn("请输入帐号密码！")
        setLoading(true)
        const res = await UserService.login({account, password});
        setLoading(false)
        if (res.data.status !== 200) {
            message.error(res.data.msg);
            return;
        }
        message.success("登录成功");
        handler.login(res.data.result);
        hide();
    }

    return (
        <Modal
            className="modal-login"
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
        >
            <div className="modal-login__body">
                <Input
                    placeholder="请输入用户名"
                    onChange={onChangeAccount}
                    prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                />
                <Input
                    type="password"
                    onChange={onChangePassword}
                    placeholder="请输入密码"
                    prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                />
                <Button onClick={onLogin} loading={loading}>登录</Button>
                {/* <Wave width={width} height={50} bgColor="transparent" style={{position: "absolute", bottom: 0, left: 0}} /> */}
            </div>
        </Modal>
    );
}

export default App;